<template>
  <f7-page class="main-query-orders">
    <TheNavbar
      class="container-navbar"
      :nav-title="$t('commercialization.common.commercialManagement')"
      :back-btn-enable="true"
      :back-callback="BackToMain"
      :add-btn-enable="true"
      @add-btn="NavigateToNewOrder()"
    />

    <div class="container-header">
      <div class="container-header__filter display-flex">
        <UCSearchEmpty
          class="container-header__filter--search"
          @focus="OpenRightPanel"
        />
        <UCDatePicker
          id="date-filter"
          :default-value="filtros != null && filtros.fechaInicioEntrega !== null ? new Date(filtros.fechaInicioEntrega) : new Date()"
          @onchange="ChangedDateFilter"
        />
      </div>

      <div class="display-flex margin-top-half">
        <img
          class="margin-right-half"
          src="@/static/icons/ic_help.svg"
        >
        <span class="truncate text-color-arandano-tint size-12">
          {{ $t('commercialization.common.youCanSearchBySerialNumberCustomerRef') }}
        </span>
      </div>
    </div>
    <UCDayFilter
      v-if="salesOrderListByday?.length > 0"
      :default-entity-list="salesOrderListByday"
      default-title="NombreCliente"
      date-filter="FechaEntrega"
      :reference-date="datePickerDate"
      :date-range="dateRangeFilter"
      @entity-selected="SelectedClient"
    >
      <template #subtitle="{ item }">
        <div class="container-day-filter-subtitle">
          <img
            class="container-day-filter-subtitle__image margin-right-half"
            src="@/static/icons/ic_box_grey.svg"
          >
          <span class="container-day-filter-subtitle__text"> {{ item.items.length > 1 ? `${item.items.length} ${$t('commercialization.common.ordersLabel')}` : `${item.items.length} ${$t('commercialization.common.orderLabel')}` }}</span>
        </div>
      </template>
    </UCDayFilter>
    <div
      v-else
      class="display-flex flex-direction-column align-items-center text-align-center w-100 mt-12 "
    >
      <img
        class="mt-12"
        src="@/static/icons/ic_add_new.svg"
        height="55px"
        width="55px"
        @click="NavigateToNewOrder()"
      >
      <span class="size-18 font-medium margin-top">{{ $t('commercialization.salesOrders.labels.noOrders') }}</span>
      <span class="size-14 text-color-metal margin-top w-50">{{ $t('commercialization.salesOrders.labels.noOrdersText') }}</span>
    </div>
    <f7-panel
      right
      resizable
      :opened="panelDerecho"
      class="content-panel-query-order"
      @panel:closed="panelDerecho = false"
    >
      <f7-view>
        <f7-page>
          <div class="content-panel-filters">
            <div class="display-flex align-items-center justify-content-space-between border-bottom">
              <div class="display-flex align-items-center font-medium content-panel-filters__title">
                <img
                  class="padding-right-half"
                  src="@/static/icons/ic_filter.svg"
                >{{ $t('common.filter').toUpperCase() }}
              </div>
              <div>
                <img
                  class="margin-right-half"
                  src="@/static/icons/ic_info.svg"
                  width="28"
                  height="28"
                >
                <img
                  src="@/static/icons/ic_close_grey.svg"
                  width="28"
                  height="28"
                  @click="panelDerecho = false"
                >
              </div>
            </div>
            <div class="margin-top-half">
              <div>
                <UCSearchEntityERP
                  ref="UCpedidoComponent"
                  :title="$t('searchEntity.order.title.searchByOrder')"
                  :placeholder="$t('searchEntity.order.placeholder.searchByOrder')"
                  :search-text="$t('searchEntity.order.searchText')"
                  :search-cancellation-text="$t('searchEntity.order.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.order.searchNotFoundText')"
                  :procedure-for-search="orderProcedure"
                  :property-entity-shown-input="[
                    'PedidoVenta.Serie',
                    'PedidoVenta.Numero',
                    'Orden',
                  ]"
                  :property-entity-shown-list-title="[
                    'PedidoVenta.Serie',
                    'PedidoVenta.Numero',
                    'Orden',
                  ]"
                  :property-entity-shown-list-subtitle="[
                    'Orden',
                    'InfoProducto.Nombre',
                    'InfoEnvase.Nombre',
                    'InfoPale.Nombre',
                  ]"
                  :pre-property-entity-shown-list-subtitle="[
                    `${$t('common.order')}: `,
                    `${$t('common.product')}: `,
                    `${$t('common.package')}: `,
                    `${$t('common.pallet')}: `,
                  ]"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  :search-in="['.item-title', '.subtitle0', '.subtitle1', '.subtitle2', '.subtitle3']"
                  @selection="EventpedidoSelected"
                />
              </div>
              <div>
                <UCSearchEntityERP
                  ref="UCCliente"
                  :title="$t('common.customer')"
                  :placeholder="$t('searchEntity.client.placeholder.searchByClient')"
                  :search-text="$t('searchEntity.client.searchText')"
                  :search-cancellation-text="$t('searchEntity.client.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.client.searchNotFoundText')"
                  :procedure-for-search="clientProcedure"
                  :property-entity-shown-input="['Nombre']"
                  :property-entity-shown-list-title="['Nombre']"
                  :property-entity-shown-list-subtitle="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventclientSelected"
                />
              </div>
              <div>
                <UCSearchEntityERP
                  ref="UCReferecia"
                  :title="$t('common.reference')"
                  :placeholder="$t('searchEntity.reference.placeholder.searchByReference')"
                  :search-text="$t('searchEntity.reference.searchText')"
                  :search-cancellation-text="$t('searchEntity.reference.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.reference.searchNotFoundText')"
                  :property-entity-shown-input="['Referencia']"
                  :property-entity-shown-list-title="['Referencia']"
                  :property-entity-shown-list-subtitle="['Referencia']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  :show-btn-search="false"
                />
              </div>
              <div class="content-panel-filters__date">
                <div class="content-panel-filters__date--title">
                  {{ $t('common.date') }}
                </div>
                <UCDatePicker
                  id="date-range"
                  ref="datepickerRange"
                  class="content-panel-filters__input"
                  :init-null="true"
                  :default-value="null"
                  :range-picker="true"
                  @onchange="ChangedDateFilterRange"
                />
              </div>
              <div class="display-flex align-items-center mt-4">
                <img
                  src="@/static/icons/ic_reset_grey.svg"
                  height="36"
                  width="36"
                  @click="ResetValues()"
                >

                <f7-button
                  class="bg-color-metal-shade text-color-arandano-white w-100 margin-left-half"
                  :class="{ disabled: !disableBtn }"
                  @click="SearchOrder(); panelDerecho = false"
                >
                  {{ $t('common.searchNow') }}
                </f7-button>
              </div>
            </div>
          </div>
        </f7-page>
      </f7-view>
    </f7-panel>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useAppOrdersStore } from '@/js/stores/appOrders';
import { useParamRef } from '@erpagroapp/params';

import TheNavbar from '@/components/TheNavbar.vue';
import UCDayFilter from '@/components/common/UCDayFilter.vue';
import UCSearchEmpty from '@/components/common/UCSearchEmpty.vue';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import {
  HiDialog,
} from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { f7 } from 'framework7-vue';
// import ejemploExpe, { pedidoAgrupadoPorCliente } from './data/datos';

/** @import { SPApp } from '@erpagroapp/types' */

export default {
  name: 'QueryOrders',

  components: {
    TheNavbar,
    UCDayFilter,
    UCSearchEntityERP,
    UCSearchEmpty,
    UCDatePicker,
  },

  props: {
    filtros: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      panelDerecho: false,
      pedido: null,
      cliente: null,
      referencia: null,
      fechaInicioFiltro: null,
      fechaFinFiltro: null,
      fechaInicioEntrega: null,
      fechaFinEntrega: null,
      fechaEntrega: null,
      datePickerDate: new Date(),
      orderList: null,
      filtrarPedidosVentaVendedorAPP: useParamRef('FiltrarPedidosVentaVendedorAPP'),
    };
  },
  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),

    ...mapWritableState(useAppOrdersStore, [
      'dataClient',
      'salesOrderListByday',
      'filters',
    ]),
    sellerSubjectId() {
      return this.filtrarPedidosVentaVendedorAPP
        ? this.userEnviroment.EntornoDeTrabajo.Usuario.Sujeto?.Id
        : 0;
    },

    clientProcedure() {
      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_ClientesXIdGrupoEmpresarial',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'q:' },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id },
          { NombreParametro: 'fechaComprobacionBloqueos', Valor: new Date() },
          { NombreParametro: 'idSujetoVendedor', Valor: this.sellerSubjectId },
        ],
        EntidadMapear: 'Comun.ClienteJSON',
      });
    },
    orderProcedure() {
      const fechaActual = new Date();
      let fechaInicio = new Date(fechaActual);
      fechaInicio.setMonth(fechaActual.getMonth() - 1);
      fechaInicio = HiDateTimeSupport.FormatDateTime(fechaInicio, 'YYYY-MM-DD');

      let fechaFin = new Date(fechaActual);
      fechaFin.setMonth(fechaActual.getMonth() + 1);
      fechaFin = HiDateTimeSupport.FormatDateTime(fechaFin, 'YYYY-MM-DD');

      return /** @satisfies {SPApp} */ ({
        NombreSP: 'APPERPAGRO_LineasPedidoVentaAPPPedidos',
        Parametros: [
          { NombreParametro: 'filtro', Valor: 'Id:' },
          { NombreParametro: 'fechaInicio', Valor: fechaInicio },
          { NombreParametro: 'fechaFin', Valor: fechaFin },
        ],
        EntidadMapear: 'Ventas.LineaPedidoVentaJSON',
      });
    },

    disableBtn() {
      return (this.pedido !== null || this.cliente !== null
        || this.referencia !== null || this.fechaInicioFiltro !== null);
    },
    dateRangeFilter() {
      if (this.fechaInicioFiltro && this.fechaFinFiltro) {
        return {
          StartDate: this.fechaInicioFiltro,
          EndDate: this.fechaFinFiltro,
        };
      }
      return null;
    },
  },

  mounted() {
    this.StartComponent();
  },
  methods: {
    async StartComponent() {
      Log(this, this.StartComponent.name);
      if (this.filtros == null) {
        const dateToday = HiDateTimeSupport.FormatDateTime(new Date(), 'YYYY-MM-DD');
        const fechaInicial = new Date(dateToday);
        fechaInicial.setDate(fechaInicial.getDate() + 3);
        const fechaFinal = fechaInicial.toISOString().split('T')[0];
        this.fechaEntrega = dateToday;
        this.fechaInicioEntrega = dateToday;
        this.fechaFinEntrega = fechaFinal;
      } else {
        /* this.fechaInicioFiltro = this.filtros.fechaInicio;
        this.fechaFinFiltro = this.filtros.fechaFin; */
        this.fechaInicioEntrega = this.filtros.fechaInicioEntrega;
        this.fechaFinEntrega = this.filtros.fechaFinEntrega;
        /* this.pedido = this.filtros.id_Pedido;
        this.cliente = this.filtros.id_Cliente;
        this.referencia = this.filtros.referencia; */
      }

      // await this.GetQueryOrders();
    },

    NavigateToNewOrder() {
      Log(this, this.NavigateToNewOrder.name); // TODO: cambiar luego por pagina de Nada
      f7.views.main.router.navigate('/frmNewOrder/');
    },

    SelectedClient(value) {
      Log(this, this.SelectedClient.name);

      this.dataClient = value.items[0].Cliente;
      f7.views.main.router.navigate('/orderInquiry/', {
        props: {
          order: value,
          filtros: this.filters,
        },
      });
    },

    async GroupByCustomer(data) {
      Log(this, this.GroupByCustomer.name);
      const result = {};

      for (const item of data) {
        const codigoCliente = item.Cliente.Codigo;
        const nombreCliente = item.Cliente.Nombre;
        const fechaEntrega = item.FechaEntrega;
        const key = `${codigoCliente}-${fechaEntrega}`;

        if (result[key]) {
          result[key].items.push(item);
        } else {
          result[key] = {
            NombreCliente: nombreCliente,
            CodigoCliente: codigoCliente,
            FechaEntrega: fechaEntrega,
            items: [item],
          };
        }
      }

      const res = Object.values(result);

      this.salesOrderListByday = res;
    },

    async ChangedDateFilter(newDateValue) {
      Log(this, this.ChangedDateFilter.name);
      this.datePickerDate = HiDateTimeSupport.FormatDateTime(newDateValue, 'YYYY-MM-DD');
      const fechaInicial = new Date(this.datePickerDate);
      fechaInicial.setDate(fechaInicial.getDate() + 3);
      const fechaFinal = fechaInicial.toISOString().split('T')[0];
      this.fechaEntrega = this.datePickerDate;
      this.fechaInicioEntrega = this.datePickerDate;
      this.fechaFinEntrega = fechaFinal;
      await this.GetQueryOrders();
    },
    ChangedDateFilterRange(newDateValue) {
      Log(this, this.ChangedDateFilterRange.name);
      if (newDateValue && newDateValue.Init && newDateValue.End) {
        this.fechaInicioFiltro = HiDateTimeSupport.FormatDateTime(newDateValue.Init, 'YYYY-MM-DD');
        this.fechaFinFiltro = HiDateTimeSupport.FormatDateTime(newDateValue.End, 'YYYY-MM-DD');
      }
    },

    OpenRightPanel(presed) {
      Log(this, this.OpenRightPanel.name);
      this.panelDerecho = presed;
    },
    BackToMain() {
      f7.views.main.router.clearPreviousHistory();
      f7.views.main.router.navigate('/', { force: true });
    },

    EventpedidoSelected(selected) {
      Log(this, this.EventpedidoSelected.name);
      if (selected != null) {
        this.pedido = selected.PedidoVenta.Id;
      } else {
        this.pedido = null;
      }
    },

    EventclientSelected(client) {
      Log(this, this.EventclientSelected.name);
      if (client != null) {
        this.cliente = client.Id;
      } else {
        this.cliente = null;
      }
    },

    ResetValues() {
      Log(this, this.ResetValues.name);
      this.pedido = null;
      this.cliente = null;
      this.referencia = null;
      this.fechaInicioFiltro = null;
      this.fechaFinFiltro = null;

      this.$refs.UCpedidoComponent.Clear();
      this.$refs.UCCliente.Clear();
      this.$refs.UCReferecia.Clear();
      this.$refs.datepickerRange.clear();
      const fechaInicial = new Date(this.datePickerDate);
      fechaInicial.setDate(fechaInicial.getDate() + 3);
      const fechaFinal = fechaInicial.toISOString().split('T')[0];
      this.fechaInicioEntrega = this.fechaEntrega;
      this.fechaFinEntrega = fechaFinal;
      this.GetQueryOrders();
    },

    FormatDate(date) {
      Log(this, this.FormatDate.name);
      const opciones = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      };
      const newDate = new Date(date).toLocaleDateString('es-Es', opciones);

      return newDate;
    },

    SearchOrder() {
      Log(this, this.SearchOrder.name);

      const inputReferencia = this.$refs.UCReferecia.GetInputValue();
      if (inputReferencia === '') {
        this.referencia = null;
      } else {
        this.referencia = inputReferencia;
      }

      if (this.fechaInicioFiltro != null || this.fechaFinFiltro != null) {
        this.fechaInicioEntrega = null;
        this.fechaFinEntrega = null;
      }
      this.GetQueryOrders();
    },

    // **************************** CONEXIONES ********************************** \\
    async GetQueryOrders() {
      Log(this, this.GetQueryOrders.name);
      HiDialog.Preloader(true, this.$t('commercialization.info.loadingSalesOrdersList'), false);
      this.salesOrderListByday = null;
      const filtro = {
        fechaInicio: this.fechaInicioFiltro,
        fechaFin: this.fechaFinFiltro,
        fechaInicioEntrega: this.fechaInicioEntrega,
        fechaFinEntrega: this.fechaFinEntrega,
        id_Pedido: this.pedido,
        id_Cliente: this.cliente,
        referencia: this.referencia,
      };
      this.filters = filtro;

      try {
        const result = await callExecuteSPERP(
          'APPERPAGRO_ObtenerPedidoVentaFecha',
          [
            { NombreParametro: 'fechaInicio', Valor: this.fechaInicioFiltro },
            { NombreParametro: 'fechaFin', Valor: this.fechaFinFiltro },
            { NombreParametro: 'fechaInicioEntrega', Valor: this.fechaInicioEntrega },
            { NombreParametro: 'fechaFinEntrega', Valor: this.fechaFinEntrega },
            { NombreParametro: 'id_Pedido', Valor: this.pedido },
            { NombreParametro: 'id_Cliente', Valor: this.cliente },
            { NombreParametro: 'referencia', Valor: this.referencia },
            { NombreParametro: 'idCentro', Valor: this.userEnviroment.EntornoDeTrabajo.Centro?.Id },
            { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa?.Id },
            { NombreParametro: 'idSujetoVendedor', Valor: this.sellerSubjectId },
          ],
          'Ventas.PedidoVentaJSON',
        );

        this.orderList = result.data;
        this.GroupByCustomer(this.orderList);
      } catch (error) {
        LogError(this, this.GetQueryOrders.name, error);
      }

      HiDialog.Preloader(false);
    },
  },
};
</script>

<style lang="scss">
.main-query-orders {
  .page-content {
    overflow-y: hidden
  }
  .container-navbar{
    .navbar-inner {
      .title {
          font-size: 16px;
          font-weight: 400;
      }
    }
  }
  .container-header{
    --date-picker-input-color: var(--search-input-color);
    background: var(--f7-bars-bg-color);
    padding: 2px 14px 0px 14px;
    height: 92px;
    margin-top: -1px;
    &__filter{
      margin-top: 10px;
      &--search{
        height: 46px;
        width: 100%;
        margin-right: 10px;
        background-color: var(--search-input-bg-color);
        border-radius: var(--search-input-border-radius);
        border: var(--search-input-border);
        input{
          height: var(--search-input-height);
          color: var(--search-input-color);
          font-size: var(--search-input-font-size);
          padding: var(--search-input-padding);
        }
        .container__img{
          height: 44px;
          min-width: var(--search-btn-min-width);
          border-left: var(--search-btn-border-left);
          background: var(--search-btn-bg-color);
          img{
            width: var(--search-btn-search-img-size);
            height: var(--search-btn-search-img-size);
          }
        }
      }
    }
  }
  .container-day-filter-subtitle{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--his-metal);
    font-size: 16px;
    font-weight: 500;
    align-items: center;
    margin-top: 8px;
  }

}

.content-panel-query-order{
  --f7-panel-width: 280px;
  .content-panel-filters{
    display: flex;
    flex-direction: column;
    padding: 12px;
    --search-title-color: var(--his-tierra);
    --search-input-height: 36px;
    --search-input-font-size: 14px;
    --search-input-font-weight: 400;
    --search-btn-min-width: 40px;

    .content-searcher-erp .content-searcher-erp-group .div-qr-search{
      margin-right: 0px;
      img{
        width: 23px;
      }
    }
    &__title{
      color: var(--his-metal-dark)
    }
    &__date{
      --date-picker-input-height: var(--search-input-height);
      --date-picker-input-color: var(--search-input-color);
      &--title {
        color: var(--search-title-color);
        font-size: var(--search-title-font-size);
        font-weight: var(--search-title-weight);
        margin: var(--search-title-margin);
        padding: var(--search-title-padding);
      }
      /* color: var(--search-title-color); */
    }
  }

}
</style>
